let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9y5Sq")).then(() => parcelRequire('kssqx'));